import React from 'react'
import {Icon} from '@chakra-ui/react'

const TechnicalSpecsIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" fill="none" {...props}>
            <path
                d="M3.71903 12.25L2.33434 9.95312C2.19159 9.70205 2.15394 9.40469 2.22962 9.12596C2.30529 8.84723 2.48814 8.60974 2.73827 8.46532C2.9884 8.32091 3.28549 8.28129 3.56472 8.35512C3.84395 8.42894 4.08265 8.61021 4.22872 8.85938L5.25028 10.5V4.59375C5.25028 4.30367 5.36552 4.02547 5.57063 3.82035C5.77575 3.61523 6.05395 3.5 6.34403 3.5C6.63411 3.5 6.91231 3.61523 7.11743 3.82035C7.32255 4.02547 7.43778 4.30367 7.43778 4.59375V7.65625C7.43778 7.36617 7.55302 7.08797 7.75813 6.88285C7.96325 6.67773 8.24145 6.5625 8.53153 6.5625C8.82161 6.5625 9.09981 6.67773 9.30493 6.88285C9.51005 7.08797 9.62528 7.36617 9.62528 7.65625V8.53125C9.62528 8.24117 9.74052 7.96297 9.94563 7.75785C10.1508 7.55273 10.429 7.4375 10.719 7.4375C11.0091 7.4375 11.2873 7.55273 11.4924 7.75785C11.6975 7.96297 11.8128 8.24117 11.8128 8.53125V10.5C11.8128 11.2569 11.7171 11.8672 11.594 12.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.0625 4.59375C3.0625 3.72351 3.4082 2.88891 4.02356 2.27356C4.63891 1.6582 5.47351 1.3125 6.34375 1.3125C7.21399 1.3125 8.04859 1.6582 8.66394 2.27356C9.2793 2.88891 9.625 3.72351 9.625 4.59375"
                stroke="var(--chakra-colors-foreground-neutral-dim)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default TechnicalSpecsIcon
